export default function (objects) {
  objects.forEach((obj) => {
    if (obj.type && obj.type.toLowerCase().includes('image')) {
      obj.crossOrigin = "Anonymous";
    }
  });
}
